import React, { useEffect, useRef } from 'react';

import { GOOGLE_CLIENT_ID } from '../../../src/env';

export default function MarketingLeadCaptureWithGoogle({
  eventName,
  leadType,
  returningUri,
  text = 'continue_with',
  verificationUri,
}: {
  eventName: 'createLeadWithGoogle' | 'unlockContentWithGoogle';
  leadType: string;
  returningUri?: string;
  text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
  verificationUri: string;
}) {
  const googleSignInButton = useRef(null);

  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback:
        eventName === 'createLeadWithGoogle'
          ? window.createLeadWithGoogle
          : window.unlockContentWithGoogle,
    });

    window.google.accounts.id.renderButton(googleSignInButton.current, {
      type: 'standard',
      text,
      width: 250,
    });
  }, [eventName, text]);

  return (
    <div
      ref={googleSignInButton}
      data-callback={eventName}
      data-redirect-uri={verificationUri}
      data-returning-uri={returningUri}
      data-lead-type={leadType}
    />
  );
}
